import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import JSON files directly
import enTranslations from './locales/en.json';
import ukTranslations from './locales/uk.json';

const resources = {
  en: { core: enTranslations },
  uk: { core: ukTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'app-language',
    },

    defaultNS: 'app',
    ns: ['core', 'app'],

    // Support for dynamic language loading
    load: 'all',
  });

export { i18n };
